import { getAssetIcon as baseGetAssetIcon } from '../../GetAssetIcon';

// Wrapper to keep existing call sites working.
// We ignore the `scene` argument and delegate to the shared gridpage getAssetIcon,
// so AppLeftSection uses the same icon logic as the rest of the app.
export const getAssetIcon = (asset, assetType, scene) => {
  return baseGetAssetIcon(asset, assetType);
};

